import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import {
  HTTPValidationError,
  ICreateQueryBulResponse,
  ICreateQueryResponse,
  ISuccessfulResponse
} from 'src/types/QueryResponse';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const milestoneQueryResponseApi = createApi({
  baseQuery,
  reducerPath: 'milestoneQueryResponseApi',
  endpoints: builder => ({
    createMilestoneQueryResponse: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        query_id: string;
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
        data: ICreateQueryResponse;
      }
    >({
      query: ({ query_id, site_id, study_id, country, application, application_section, data }) => ({
        url: formatString(
          endPoints.MilestoneQueryResponse.create,
          { key: urlKeys.query_id, value: query_id },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'POST',
        body: data
      })
    }),
    createMilestoneQueryBulkResponse: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
        data: ICreateQueryBulResponse;
      }
    >({
      query: ({ site_id, study_id, country, application, application_section, data }) => ({
        url: formatString(
          endPoints.MilestoneQueryResponse.bulkCreate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'POST',
        body: data
      })
    }),
    getMilestoneQueryResponse: builder.query<
      ISuccessfulResponse | HTTPValidationError,
      {
        query_id: string;
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
      }
    >({
      query: ({ query_id, site_id, study_id, country, application, application_section }) => ({
        url: formatString(
          endPoints.MilestoneQueryResponse.select,
          { key: urlKeys.query_id, value: query_id },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'GET'
      })
    })
  })
});

export const {
  useCreateMilestoneQueryResponseMutation,
  useGetMilestoneQueryResponseQuery,
  useCreateMilestoneQueryBulkResponseMutation
} = milestoneQueryResponseApi;
